import { ConversationStatus } from 'generated-graphql/graphql';

export const conversationAutomationStatusOptions: {
  label: string;
  value: ConversationStatus;
}[] = [
  {
    label: 'Not interested',
    value: ConversationStatus.CompletedNotInterested
  },
  {
    label: 'Opted out',
    value: ConversationStatus.OptedOut
  },
  {
    label: 'Closed',
    value: ConversationStatus.Completed
  }
];
